<template>
  <slot />
</template>

<script setup lang="ts">
import { provide } from 'vue';

defineOptions({ name: 'SubRenderingProvider' });

const props = defineProps<{
  fields: Record<string, any>;
  dataSource: string;
}>();

provide('fields', props.fields);
provide('rendering', { dataSource: props.dataSource });
</script>
